import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=33dd09c0&scoped=true"
import script from "./DocumentsList.vue?vue&type=script&lang=js"
export * from "./DocumentsList.vue?vue&type=script&lang=js"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=33dd09c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dd09c0",
  null
  
)

export default component.exports